import { ICustomerUser } from './customer.dto';

export class InjectionLog {
  _id: string;
  customer: string | ICustomerUser;
  medicationName: string;
  dosage: string;
  injectionSite: string; // 'abdomen' | 'thigh' | 'upper_arm' | 'other'
  injectionTakenAt: Date;
  notes: string;
  createdAt?: Date;
  updatedAt?: Date;
  organization?: string;
}

export interface InjectionLogQueryParams {
  id?: string;
  customer?: string | ICustomerUser;
  medicationName?: string;
  injectionSite?: string;
  minInjectionDate?: string;
  maxInjectionDate?: string;
  limit?: number;
  offset?: number;
  sortField?: string;
  sortOrder?: number;
}

export class IInjectionLog extends InjectionLog {}
